<template>
  <div class="container">
    <div class="sidebar">
        <ul>
            <li><router-link to="/tools/unicode">Unicode 编解码</router-link></li>
            <li><router-link to="/tools/url">Url 编解码</router-link></li>
            <li><router-link to="/tools/base64">Base64 编解码</router-link></li>
            <li><router-link to="/tools/hex">Hex 编解码</router-link></li>
        </ul>
    </div>
    <div class="main-content">
        <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style scoped>
.container {
    display: flex;
    flex: 1;
}

.sidebar {
    width: 200px !important;
    flex-shrink: 0 !important;
    background-color: #f4f4f4;
    padding: 5px 10px;
    box-sizing: border-box !important;
    text-align: center;
}

.sidebar ul {
    list-style-type: none;
    padding: 0;
}

.sidebar li {
    margin: 10px 0;
}

.sidebar a {
    text-decoration: none;
    color: #333;
}

.sidebar a:hover {
    color: #4CAF50;
}

.tool-section {
    display: none;
}

.tool-section.active {
    display: block;
}

.main-content {
    flex-grow: 1;
    padding: 10px 20px;
    box-sizing: border-box;
}


</style>

